export default defineNuxtRouteMiddleware(() => {
  const user = useSanctumUser()

  // @ts-ignore
  if (!user.value?.permissions.includes('ManageFinances')) {
    // @ts-ignore
    if (!user.value?.company.subscription.is_subscribed) {
      return showError({
        statusCode: 402,
        // @ts-ignore
        message: `A assinatura da empresa ${user.value?.company.name} atualmente está inativa ou pendente de pagamento. Por favor, contate o administrador dela para mais informações.`,
      })
    }

    return showError({
      statusCode: 403,
    })
  }
})
